import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const newAccountConnectionsContainerCss = "nau1i35";
export const NewAccountConnectionsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(newAccountConnectionsContainerCss, props.className)} />;
});
const logoWrapperCss = "l899px3";
export const LogoWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(logoWrapperCss, props.className)} />;
});
const providerGroupTitleWrapperCss = "pr7gzmo";
export const ProviderGroupTitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(providerGroupTitleWrapperCss, props.className)} />;
});
const exchangeFieldsContainerWithMarginCss = "easjewr";
const exchangeFieldsContainerCss = "e1jh8cm9";
export const ExchangeFieldsContainer = forwardRef((props, ref) => {
  const {
    withMargin,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(exchangeFieldsContainerCss, {
    [exchangeFieldsContainerWithMarginCss]: withMargin
  }, props.className)} />;
});
const formErrorsContainerCss = "f2d9849";
export const FormErrorsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formErrorsContainerCss, props.className)} />;
});
export const OptionalLabel = ({
  children
}) => <>
    <BodyText weight="bold">
      {children}
    </BodyText>
    <BodyText color="muted">
      (
      {I18n.t('publisher.availability_settings.section.calendar_settings.account_connection_popup.exchange.optional')}
      )
    </BodyText>
  </>;
export const ExchangeHelpCenterLink = ({
  children
}) => <Link href="https://calendly.com/help/how-to-connect-your-microsoft-exchange-calendar" target="_blank" rel="noopener">
    {children}
  </Link>;

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");